import React from 'react';
import { Checkbox } from '@noths/polaris-client-ribbons-design-system';
import { CurrencyCode } from '@noths/polaris-dev-ts-types';

import { ProductOptionValue } from 'src/types';
import { getFormattedPersonalisationAmount } from 'src/utils';
import * as styles from '../../styles/SelectionOptionValue.styles';

interface SelectedCheckboxOptionProps {
  currency: CurrencyCode;
  error: boolean;
  value: ProductOptionValue;
  isSelected: boolean;
  id: string;
  name: string;
  onChange: (value: ProductOptionValue | null) => void;
  onFocus?: () => void;
}

export const SelectedCheckboxOption = ({
  currency,
  value,
  isSelected,
  id,
  name,
  error,
  onChange,
  onFocus,
}: SelectedCheckboxOptionProps) => {
  const { isNegative = false, value: formattedPriceValue = '' } = value.priceModifier
    ? getFormattedPersonalisationAmount(currency, value.priceModifier)
    : {};

  return (
    <div css={styles.wrapper} data-is-selected={isSelected}>
      <Checkbox
        id={id}
        name={name}
        checked={isSelected}
        onChange={() => onChange(value)}
        onFocus={onFocus}
        {...{ 'aria-invalid': error }}
      />
      <label css={styles.label} htmlFor={id}>
        <span dangerouslySetInnerHTML={{ __html: value.name }} />
        {value.priceModifier && (
          <span css={styles.priceModifier}>
            <span data-is-negative={isNegative} css={styles.priceOperator}>
              {isNegative ? <>&minus;</> : <>&#43;</>}
            </span>
            <span>{formattedPriceValue.replace('-', '')}</span>
          </span>
        )}
      </label>
    </div>
  );
};
